import Reveal from "Components/marketing/Reveal";
import {
  EARNING_TIERS,
  BONUS_THRESHOLD_PCT,
  SPONSORSHIP_MAX,
} from "commons/earnings.constants";
import { formatInr, formatInrCompact } from "services/earnings.service";

/**
 * The three ways a community earns, from the Revenue Slide.
 *
 * Numbered because these genuinely are three distinct streams a partner should
 * be able to refer to by number in a conversation — not decoration.
 * Every figure is derived from the earnings constants, never typed by hand.
 */
function StreamList({ compact = false }) {
  const topTier = EARNING_TIERS[EARNING_TIERS.length - 1];

  const streams = [
    {
      title: "A share of every booking",
      body: (
        <>
          Up to{" "}
          <strong className="font-semibold text-foreground">
            {Math.round(topTier.share * 100)}%
          </strong>{" "}
          of the platform fee your members generate on ShoUp. It scales with your
          tier.
        </>
      ),
    },
    {
      title: "A monthly performance bonus",
      body: (
        <>
          Up to{" "}
          <strong className="font-semibold text-foreground">
            {formatInr(topTier.bonusMax)} a month
          </strong>
          , unlocked when {BONUS_THRESHOLD_PCT}% of your members book in that
          month.
        </>
      ),
    },
    {
      title: "Fixed sponsorship support",
      body: (
        <>
          Up to{" "}
          <strong className="font-semibold text-foreground">
            {formatInrCompact(SPONSORSHIP_MAX)}
          </strong>
          , agreed with you. Brand partnerships follow as momentum builds.
        </>
      ),
    },
  ];

  return (
    <ol className={compact ? "space-y-5" : "space-y-8"}>
      {streams.map((stream, index) => (
        <Reveal as="li" key={stream.title} delay={index * 90}>
          <div className="flex gap-5">
            <span
              className={`font-display font-bold leading-none text-[hsl(var(--brand-lavender))] ${
                compact ? "text-2xl" : "text-3xl md:text-4xl"
              }`}
            >
              {index + 1}
            </span>
            <div>
              <h3
                className={`font-display font-semibold tracking-tight text-foreground ${
                  compact ? "text-base" : "text-xl md:text-2xl"
                }`}
              >
                {stream.title}
              </h3>
              <p
                className={`mt-1.5 leading-relaxed text-muted-foreground ${
                  compact ? "text-sm" : "text-base md:text-lg"
                }`}
              >
                {stream.body}
              </p>
            </div>
          </div>
        </Reveal>
      ))}
    </ol>
  );
}

export default StreamList;
